module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // define __esModule on exports

  /******/


  __webpack_require__.r = function (exports) {
    /******/
    if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/
      Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/


    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/

  /******/
  // create a fake namespace object

  /******/
  // mode & 1: value is a module id, require it

  /******/
  // mode & 2: merge all properties of value into the ns

  /******/
  // mode & 4: return value when already ns object

  /******/
  // mode & 8|1: behave like require

  /******/


  __webpack_require__.t = function (value, mode) {
    /******/
    if (mode & 1) value = __webpack_require__(value);
    /******/

    if (mode & 8) return value;
    /******/

    if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
    /******/

    var ns = Object.create(null);
    /******/

    __webpack_require__.r(ns);
    /******/


    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/

    if (mode & 2 && typeof value != 'string') for (var key in value) __webpack_require__.d(ns, key, function (key) {
      return value[key];
    }.bind(null, key));
    /******/

    return ns;
    /******/
  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = "./src/Select/index.ts");
  /******/
}
/************************************************************************/

/******/
({
  /***/
  "./src/Select/index.ts":
  /***/
  function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__); // EXTERNAL MODULE: external "react"


    var external_react_ = __webpack_require__("react");

    var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_); // EXTERNAL MODULE: external "@carvana/icons/ArrowDown"


    var ArrowDown_ = __webpack_require__("@carvana/icons/ArrowDown");

    var ArrowDown_default = /*#__PURE__*/__webpack_require__.n(ArrowDown_); // EXTERNAL MODULE: external "@carvana/icons/ArrowUpFilled"


    var ArrowUpFilled_ = __webpack_require__("@carvana/icons/ArrowUpFilled");

    var ArrowUpFilled_default = /*#__PURE__*/__webpack_require__.n(ArrowUpFilled_); // EXTERNAL MODULE: external "styled-components"


    var external_styled_components_ = __webpack_require__("styled-components");

    var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_); // CONCATENATED MODULE: ./src/Select/Select.styles.tsx


    var SelectWrapper = external_styled_components_default.a.div.withConfig({
      displayName: "SelectWrapper",
      componentId: "y2w0ai-0"
    })(["position:relative;height:57px;font-family:", ";"], function (props) {
      return props.theme.typography.fontFamily;
    });
    var ValueText = external_styled_components_default.a.span.withConfig({
      displayName: "ValueText",
      componentId: "y2w0ai-1"
    })(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);

    var labelWithValue = function labelWithValue(props) {
      return props.hasValue && "\n  height: 9px;\n  margin-bottom: 8px;\n  font-size: 10px;\n  color: " + props.theme.carvana.blue.primary + ";\n";
    };

    var SelectLabel = external_styled_components_default.a.label.withConfig({
      displayName: "SelectLabel",
      componentId: "y2w0ai-2"
    })(["height:14px;margin-bottom:5px;color:", ";color:", ";font-size:14px;font-weight:700;text-align:left;cursor:pointer;transition:font-size 200ms ease-out,color 200ms ease-out;", ""], function (props) {
      return props.theme.carvana.gray.dark;
    }, function (props) {
      return props.disabled && props.theme.carvana.gray.medium;
    }, labelWithValue);
    var IconWrapper = external_styled_components_default.a.div.withConfig({
      displayName: "IconWrapper",
      componentId: "y2w0ai-3"
    })(["width:10px;height:15px;margin-right:8px;color:", ";"], function (props) {
      return props.theme.carvana.blue.primary;
    });

    var visibleDropdown = function visibleDropdown(p) {
      return p.showDropdown && "\n  border: 1px solid transparent;\n  border-radius: 3px 3px 0px 0px;\n  box-shadow: 0 7px 13px 1px rgba(24, 41, 60, 0.1);\n  border-bottom: 1px solid " + p.theme.carvana.gray.medium + ";\n";
    };

    var SelectMenuDefault = external_styled_components_default.a.button.withConfig({
      displayName: "SelectMenuDefault",
      componentId: "y2w0ai-4"
    })(["display:flex;align-items:center;justify-content:space-between;height:100%;width:100%;margin:0;background-color:", ";border:1px solid ", ";border-radius:3px;cursor:pointer;font-size:14px;font-weight:700;line-height:20px;text-align:left;text-transform:uppercase;&:disabled{background-color:transparent;color:", ";svg{color:", ";}label{color:", ";}}&:focus{outline:0;border-color:", ";box-shadow:0 7px 13px 1px rgba(24,41,60,0.1);border-radius:3px 3px 0 0;border-bottom:1px solid ", ";}&:focus-within ", "{color:", ";}&:focus-within ", "{color:", ";}", ""], function (props) {
      return props.theme.carvana.white.primary;
    }, function (props) {
      return props.theme.carvana.gray.light;
    }, function (props) {
      return props.theme.carvana.gray.light;
    }, function (props) {
      return props.theme.carvana.gray.light;
    }, function (props) {
      return props.theme.carvana.gray.light;
    }, function (props) {
      return props.theme.carvana.white.primary;
    }, function (props) {
      return props.theme.carvana.gray.light;
    }, SelectLabel, function (props) {
      return props.theme.carvana.gray.dark;
    }, IconWrapper, function (props) {
      return props.theme.carvana.blue.primary;
    }, visibleDropdown);
    var SelectLabelDefault = external_styled_components_default.a.div.withConfig({
      displayName: "SelectLabelDefault",
      componentId: "y2w0ai-5"
    })(["display:flex;flex-flow:column;padding:0 12px;padding-left:10px;min-width:0;color:", ";"], function (props) {
      return props.theme.carvana.gray.dark;
    });
    var DropdownMenuDefault = external_styled_components_default.a.div.withConfig({
      displayName: "DropdownMenuDefault",
      componentId: "y2w0ai-6"
    })(["position:absolute;display:block;width:100%;z-index:1;max-height:245px;background-color:", ";border-radius:0px 0px 3px 3px;box-shadow:0 7px 13px 1px rgba(24,41,60,0.1);overflow-y:auto;overflow-x:hidden;&::-webkit-scrollbar{width:6px;background-color:", ";}&::-webkit-scrollbar-thumb{border-radius:8px;background-color:", ";}&::-webkit-scrollbar-track{border-radius:8px;background-color:", ";}"], function (props) {
      return props.theme.carvana.white.primary;
    }, function (props) {
      return props.theme.carvana.gray.light;
    }, function (props) {
      return props.theme.carvana.blue.dark;
    }, function (props) {
      return props.theme.carvana.gray.light;
    });
    var DropdownItemDefault = external_styled_components_default.a.div.withConfig({
      displayName: "DropdownItemDefault",
      componentId: "y2w0ai-7"
    })(["display:flex;justify-content:space-between;align-items:center;padding:18px 13px 18px 19px;color:", ";color:", ";font-size:14px;font-weight:700;text-align:left;cursor:pointer;&:hover{background-color:", ";color:", ";}"], function (props) {
      return props.theme.carvana.blue.dark;
    }, function (props) {
      return props.isSelected && props.theme.carvana.gray.medium;
    }, function (props) {
      return props.theme.carvana.blue.dark;
    }, function (props) {
      return props.theme.carvana.white.primary;
    }); // CONCATENATED MODULE: ./src/Select/IconToggle.tsx

    var IconToggle_IconToggle = function IconToggle(_ref) {
      var condition = _ref.condition,
          TruthyIcon = _ref.ifTrue,
          FalsyIcon = _ref.ifFalse,
          _ref$className = _ref.className,
          className = _ref$className === void 0 ? '' : _ref$className;
      var IconToShow = condition ? TruthyIcon : FalsyIcon;
      return IconToShow ? /*#__PURE__*/external_react_default.a.createElement(IconWrapper, {
        className: className
      }, /*#__PURE__*/external_react_default.a.createElement(IconToShow, {
        width: 10,
        height: 20
      })) : null;
    };
    /* harmony default export */


    var Select_IconToggle = IconToggle_IconToggle; // EXTERNAL MODULE: external "@carvana/icons/Checkmark"

    var Checkmark_ = __webpack_require__("@carvana/icons/Checkmark");

    var Checkmark_default = /*#__PURE__*/__webpack_require__.n(Checkmark_); // CONCATENATED MODULE: ./src/Select/Option.tsx


    var Option_Option = function Option(_ref) {
      var option = _ref.option,
          DropdownIcon = _ref.DropdownIcon,
          DropdownItem = _ref.DropdownItem,
          template = _ref.template,
          id = _ref.id,
          index = _ref.index,
          isSelected = _ref.isSelected,
          handleOptionSelection = _ref.handleOptionSelection;
      return /*#__PURE__*/external_react_default.a.createElement(DropdownItem, {
        onClick: function onClick(e) {
          return handleOptionSelection(e, index);
        },
        isSelected: isSelected,
        "data-value": option.value,
        id: "option-" + index + "-" + id,
        "aria-selected": isSelected,
        role: "option"
      }, template(option, false), /*#__PURE__*/external_react_default.a.createElement(DropdownIcon, {
        condition: isSelected,
        ifTrue: Checkmark_default.a
      }));
    };
    /* harmony default export */


    var Select_Option = Option_Option; // CONCATENATED MODULE: ./src/Select/Select.tsx

    function _extends() {
      _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      return _extends.apply(this, arguments);
    }

    function _objectWithoutPropertiesLoose(source, excluded) {
      if (source == null) return {};
      var target = {};
      var sourceKeys = Object.keys(source);
      var key, i;

      for (i = 0; i < sourceKeys.length; i++) {
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
      }

      return target;
    }
    /* eslint-disable import/no-duplicates */


    var Select_Select = function Select(_ref) {
      var _ref$className = _ref.className,
          className = _ref$className === void 0 ? '' : _ref$className,
          _ref$testHook = _ref.testHook,
          testHook = _ref$testHook === void 0 ? '' : _ref$testHook,
          _ref$disabled = _ref.disabled,
          disabled = _ref$disabled === void 0 ? false : _ref$disabled,
          label = _ref.label,
          _ref$onChange = _ref.onChange,
          onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
          options = _ref.options,
          _ref$initialValue = _ref.initialValue,
          initialValue = _ref$initialValue === void 0 ? '' : _ref$initialValue,
          id = _ref.id,
          _ref$optionTemplate = _ref.optionTemplate,
          optionTemplate = _ref$optionTemplate === void 0 ? function (_ref2) {
        var display = _ref2.display;
        return /*#__PURE__*/external_react_default.a.createElement(ValueText, null, display);
      } : _ref$optionTemplate,
          _ref$Menu = _ref.Menu,
          Menu = _ref$Menu === void 0 ? SelectMenuDefault : _ref$Menu,
          _ref$MenuLabel = _ref.MenuLabel,
          MenuLabel = _ref$MenuLabel === void 0 ? SelectLabelDefault : _ref$MenuLabel,
          _ref$MenuIcon = _ref.MenuIcon,
          MenuIcon = _ref$MenuIcon === void 0 ? Select_IconToggle : _ref$MenuIcon,
          _ref$DropdownMenu = _ref.DropdownMenu,
          DropdownMenu = _ref$DropdownMenu === void 0 ? DropdownMenuDefault : _ref$DropdownMenu,
          _ref$DropdownItem = _ref.DropdownItem,
          DropdownItem = _ref$DropdownItem === void 0 ? DropdownItemDefault : _ref$DropdownItem,
          _ref$DropdownIcon = _ref.DropdownIcon,
          DropdownIcon = _ref$DropdownIcon === void 0 ? Select_IconToggle : _ref$DropdownIcon,
          rest = _objectWithoutPropertiesLoose(_ref, ["className", "testHook", "disabled", "label", "onChange", "options", "initialValue", "id", "optionTemplate", "Menu", "MenuLabel", "MenuIcon", "DropdownMenu", "DropdownItem", "DropdownIcon"]);

      var initialIndex = options.findIndex(function (v) {
        return v.value === initialValue;
      });

      var _useState = Object(external_react_["useState"])(''),
          activeDescendant = _useState[0],
          setActiveDescendent = _useState[1];

      var _useState2 = Object(external_react_["useState"])(false),
          showDropdown = _useState2[0],
          setShowDropdown = _useState2[1];

      var _useState3 = Object(external_react_["useState"])(initialIndex),
          selectedIndex = _useState3[0],
          setSelectedIndex = _useState3[1];

      var findTextValue = Object(external_react_["useRef"])('');
      var findTextTimeout = Object(external_react_["useRef"])();
      var dropdownRef = Object(external_react_["useRef"])(null);
      var buttonRef = Object(external_react_["useRef"])(null);

      var handleClickOutside = function handleClickOutside(event) {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setShowDropdown(false);
        }
      };

      Object(external_react_["useEffect"])(function () {
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside);
        return function () {
          document.removeEventListener('mousedown', handleClickOutside);
          document.removeEventListener('touchstart', handleClickOutside);
          clearTimeout(findTextTimeout.current);
        };
      }, []);
      Object(external_react_["useEffect"])(function () {
        if (!showDropdown) return setActiveDescendent('');

        var getId = function getId(index) {
          return "option-" + index + "-" + id;
        };

        return setActiveDescendent(getId(selectedIndex));
      }, [showDropdown, selectedIndex]);

      var toggleDropdown = function toggleDropdown(event) {
        setShowDropdown(!showDropdown);

        if (buttonRef.current && !showDropdown) {
          // workaround for Safari/Firefox focus: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Clicking_and_focus
          buttonRef.current.focus();
        }

        event.preventDefault();
      };

      var handleOptionSelection = function handleOptionSelection(event, index) {
        var selection = options[index];
        setSelectedIndex(index);
        toggleDropdown(event);
        onChange(selection);
      };

      var locateItemByContent = function locateItemByContent(key) {
        findTextValue.current += key;
        clearTimeout(findTextTimeout.current);
        var matchingIndex = options.findIndex(function (x) {
          var _x$display;

          return (_x$display = x.display) === null || _x$display === void 0 ? void 0 : _x$display.toLowerCase().startsWith(findTextValue.current.toLowerCase());
        });

        if (matchingIndex >= 0) {
          setSelectedIndex(matchingIndex);
          onChange(options[matchingIndex]);
        }

        findTextTimeout.current = setTimeout(function () {
          findTextValue.current = '';
        }, 500);
      };

      var keyboardEvents = function keyboardEvents(event) {
        var key = event.key;

        switch (key) {
          case 'Escape':
          case 'Tab':
            setShowDropdown(false);
            break;

          case 'ArrowDown':
            {
              if (!showDropdown) toggleDropdown(event);

              if (selectedIndex < options.length - 1) {
                setSelectedIndex(selectedIndex + 1);
              }

              break;
            }

          case 'ArrowUp':
            {
              if (!showDropdown) toggleDropdown(event);

              if (selectedIndex > 0) {
                setSelectedIndex(selectedIndex - 1);
              }

              break;
            }

          case 'Enter':
            handleOptionSelection(event, selectedIndex);
            event.target.blur();
            break;

          default:
            locateItemByContent(key);
            break;
        }
      };

      var selection = options[selectedIndex] || {};
      var optionDisplay = optionTemplate(selection, true);
      var labelId = "label-" + id;
      var dropdownId = "dropdown-" + id;
      return /*#__PURE__*/external_react_default.a.createElement(SelectWrapper, _extends({
        className: className,
        role: "combobox",
        "aria-haspopup": "listbox",
        "aria-owns": id,
        "aria-expanded": showDropdown,
        ref: dropdownRef,
        "aria-labelledby": labelId
      }, rest), /*#__PURE__*/external_react_default.a.createElement(Menu, {
        "data-cv-test": testHook || id,
        disabled: disabled,
        onClick: toggleDropdown,
        onKeyDown: keyboardEvents,
        tabIndex: 0,
        ref: buttonRef,
        id: id,
        "aria-controls": dropdownId,
        "aria-activedescendant": activeDescendant,
        "aria-labelledby": labelId,
        role: "textbox"
      }, /*#__PURE__*/external_react_default.a.createElement(MenuLabel, null, /*#__PURE__*/external_react_default.a.createElement(SelectLabel, {
        hasValue: !!selection.value,
        disabled: disabled,
        id: labelId
      }, label), optionDisplay), /*#__PURE__*/external_react_default.a.createElement(MenuIcon, {
        condition: showDropdown,
        ifTrue: ArrowUpFilled_default.a,
        ifFalse: ArrowDown_default.a
      })), /*#__PURE__*/external_react_default.a.createElement(DropdownMenu, {
        role: "listbox",
        "aria-labelledby": labelId,
        id: dropdownId
      }, showDropdown && options.map(function (option, index) {
        return /*#__PURE__*/external_react_default.a.createElement(Select_Option, {
          option: option,
          DropdownIcon: DropdownIcon,
          DropdownItem: DropdownItem,
          template: optionTemplate,
          id: id,
          index: index,
          isSelected: index === selectedIndex,
          handleOptionSelection: handleOptionSelection,
          key: option.value + "_option_" + id
        });
      })));
    };
    /* harmony default export */


    var src_Select_Select = Select_Select; // CONCATENATED MODULE: ./src/Select/index.ts

    /* concated harmony reexport Select */

    __webpack_require__.d(__webpack_exports__, "Select", function () {
      return src_Select_Select;
    });
    /* concated harmony reexport SelectMenuDefault */


    __webpack_require__.d(__webpack_exports__, "SelectMenuDefault", function () {
      return SelectMenuDefault;
    });
    /* concated harmony reexport SelectLabelDefault */


    __webpack_require__.d(__webpack_exports__, "SelectLabelDefault", function () {
      return SelectLabelDefault;
    });
    /* concated harmony reexport DropdownMenuDefault */


    __webpack_require__.d(__webpack_exports__, "DropdownMenuDefault", function () {
      return DropdownMenuDefault;
    });
    /* concated harmony reexport DropdownItemDefault */


    __webpack_require__.d(__webpack_exports__, "DropdownItemDefault", function () {
      return DropdownItemDefault;
    });
    /* concated harmony reexport IconDefault */


    __webpack_require__.d(__webpack_exports__, "IconDefault", function () {
      return Select_IconToggle;
    });
    /* harmony default export */


    var src_Select = __webpack_exports__["default"] = src_Select_Select;
    /***/
  },

  /***/
  "@carvana/icons/ArrowDown":
  /***/
  function (module, exports) {
    module.exports = require("@carvana/icons/ArrowDown");
    /***/
  },

  /***/
  "@carvana/icons/ArrowUpFilled":
  /***/
  function (module, exports) {
    module.exports = require("@carvana/icons/ArrowUpFilled");
    /***/
  },

  /***/
  "@carvana/icons/Checkmark":
  /***/
  function (module, exports) {
    module.exports = require("@carvana/icons/Checkmark");
    /***/
  },

  /***/
  "react":
  /***/
  function (module, exports) {
    module.exports = require("react");
    /***/
  },

  /***/
  "styled-components":
  /***/
  function (module, exports) {
    module.exports = require("styled-components");
    /***/
  }
  /******/

});